import { render, staticRenderFns } from "./PrimaryTTSVoice.vue?vue&type=template&id=73f1529f&scoped=true&"
import script from "./PrimaryTTSVoice.vue?vue&type=script&lang=js&"
export * from "./PrimaryTTSVoice.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryTTSVoice.vue?vue&type=style&index=0&id=73f1529f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1529f",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
